(ns client-portal.client.voice-insights.sessions.drawer.views
  (:require [client-portal.client.anonymous.data :as anon.d]
            [client-portal.client.audio.views :as audio]
            [client-portal.client.voice-insights.sessions.data :as sessions.d]
            [client-portal.client.voice-insights.tags.data :as tags.d]
            [client-portal.client.voice-insights.tag-data :as tag.d]
            [client-portal.client.voice-insights.data :as vi.d]
            [client-portal.client.layout :as l]
            ["fuse.js" :as Fuse]
            [client-portal.client.vi.components.tag :as tag]
            [client-portal.client.vi.components.tag-icon :as tag-icon]
            [clojure.string :as s]
            [shared.core.components.components :as c]
            [shared.core.amelia-light.components.components :as alc]
            [shared.core.reactive :as re]
            [shared.core.style :as style]
            [shared.core.time :as time]
            [shared.core.util :as util]))

(def upsell-tag-prefix "upsell-")
(def summary-tag-suffix "-summary")

(defn ->conv-detail [conv]
  (if (or (nil? conv) (util/loading? conv))
    :loading
    @(re/subscribe [:sessions/conversation-by-id- conv])))

(defn ->conversation-ts [conv]
  (or (:conversation-ts conv) (:conversation-ts (->conv-detail conv))))

(defn ->conversation-id [conv]
  (or (:conversation-id conv) (:conversation-id (->conv-detail conv))))

(defn ->audio-source [conv]
  (or (:audio-source conv) (:audio-source (->conv-detail conv))))

(defn ->convo-crew-type [conv]
  (or (:crew-type conv) (:crew-type (->conv-detail conv))))

(defn conversation->upsell-summary-tags [conversation]
  (let [parse-entry (fn [action entry]
                      (let [entry (s/trim entry)
                            offset (some-> (re-find #"\[(\d+)ms\]" entry) second js/parseInt)
                            text (-> entry (s/replace #"\s*\[\d+ms\]\s*$" "") s/trim)
                            trailing-paren (some-> (re-find #"\(([^)]+)\)\s*$" text) second)
                            outcome (when (#{"accept" "decline" "undetermined"} (some-> trailing-paren s/lower-case))
                                      trailing-paren)
                            item (-> text
                                     (cond-> outcome (s/replace #"\s*\([^)]+\)\s*$" ""))
                                     s/trim)]
                        {:action action
                         :item item
                         :outcome outcome
                         :offset offset}))
        parse-description (fn [description]
                            (when description
                              (->> (s/split description #";")
                                   (mapcat (fn [group]
                                             (when-let [[action entries] (some-> group (s/split #":" 2))]
                                               (mapv (partial parse-entry (s/trim action))
                                                     (s/split (s/trim entries) #",")))))
                                   vec)))]
    (some->> (->conv-detail conversation)
             :tags
             (filterv #(and (s/starts-with? (:name %) upsell-tag-prefix)
                            (s/ends-with? (:name %) summary-tag-suffix)))
             (mapv #(assoc % :values (->> (parse-description (:description %))
                                          (filterv :offset)
                                          (sort-by :offset))))
             (remove #(empty? (:values %)))
             (sort-by :name))))

(defn header []
  (let [copied-link?* (re/ratom false)
        concept-id- (re/subscribe [:concepts/current-concept-id-])
        admin?- (re/subscribe [:account/admin-role?-])
        selected-conversation- (re/subscribe [:sessions/selected-conversation-])
        qps- (re/subscribe [:router/current-query-params-])]
    (fn []
      (let [selected-conversation @selected-conversation-
            conversation-ts (->conversation-ts selected-conversation)
            conversation-id (->conversation-id selected-conversation)
            audio-source (->audio-source selected-conversation)
            convo-crew-type (->convo-crew-type selected-conversation)
            ai? (= convo-crew-type "ai")]
        [:div {:style {:background-color (style/alc-color "Background/secondary")
                       :flex "0 0 auto"
                       :display :flex
                       :gap 8
                       :padding "12px 16px"
                       :position :sticky
                       :top 0
                       :min-height 58
                       :box-sizing :border-box
                       :z-index (inc (style/z :medium))}}
         [:span {:style {:color (style/alc-color "Text/primary_header")
                         :display :flex
                         :align-items :center
                         :font-size 20
                         :font-weight 400
                         :line-height 1.4}}
          "Session Detail"]
         [c/spacer]
         (when conversation-ts
           [:div {:style {:display :flex
                          :gap 8}}
            ^{:key (str "share-" @copied-link?*)}
            [alc/tooltip
             {:tooltip-content (if @copied-link?*
                                 "Copied"
                                 "Copy Session Link")
              :target-content [alc/up-ghost-button {:icon-type (if @copied-link?* :CheckCircleIcon :CopyIcon)
                                                    :on-click #(do
                                                                 (re/dispatch [:core/copy-to-clipboard
                                                                               (sessions.d/sharable-conversation-url
                                                                                 @concept-id-
                                                                                 selected-conversation
                                                                                 convo-crew-type
                                                                                 (:ns @qps-))
                                                                               {:notify? false}])
                                                                 (reset! copied-link?* true)
                                                                 (util/wait 1500 (fn [] (reset! copied-link?* false))))}]}]
            (when (and @admin?- ai?)
              [alc/tooltip
               {:tooltip-content "Open in Admin Tool"
                :target-content [alc/up-ghost-button {:icon-type :OpenInNewIcon
                                                      :on-click #(re/dispatch
                                                                   [:sessions/open-in-admin-click
                                                                    {:conversation-id conversation-id
                                                                     :audio-source audio-source
                                                                     :dataset-id (:dataset-id selected-conversation)}])}]}])])
         [alc/up-button {:icon-type :CrossIcon
                         :rounded? true
                         :on-click #(re/dispatch [:sessions/toggle-drawer-open {:open? false}])}]]))))

(defn ->convo-loading-or-present? [conv]
  (or (util/loading? conv) (not-empty conv)))

(defn find-convo-tag [{:keys [conversation-detail tag-name tag-val]}]
  (some->> (util/when-not-loading conversation-detail)
           :tags
           (filter #(and (= (some-> (:name %) (util/->kebab-case-string)) tag-name)
                         (if tag-val
                           (= (util/->kebab-case-string (:value %)) tag-val)
                           true)))
           (first)))

(defn tag-by-name [{:keys [tags name]}]
  (some->> (when (not-empty tags) tags)
           (filterv :name)
           (filter #(s/includes? (util/->kebab-case-string (:name %))
                                 (util/->kebab-case-string name)))
           (first)))

(defn tag-material-icon [{:keys [size] :or {size 16} :as args}]
  (let [tag (tag-by-name args)
        tag-value (:value tag)]
    (cond
      (#{"greeting" "sentiment"} (:name args))
      [tag/sentiment-face {:size size
                           :sentiment tag-value}]

      :else
      [c/material-icon
       (cond
         (contains? #{"offered" "true"} tag-value)
         {:icon-type :check
          :style {:color (style/alc-color "chart/green")
                  :font-size size}}

         :else
         {:icon-type :close
          :style {:color (style/alc-color "chart/red")
                  :font-size size}})])))

(defn session-overview []
  (let [copied-convo-id?* (re/ratom false)
        selected-conversation- (re/subscribe [:sessions/selected-conversation-])
        sessions- (re/subscribe [:sessions/list-flattened-])
        next-page-loading?- (re/subscribe [:sessions/list-next-page-loading?-])
        admin?- (re/subscribe [:account/admin-role?-])
        satisfaction-name- (re/subscribe [:voice-insights/satisfaction-name-])
        ces-score?- (re/subscribe [:voice-insights/ces-feature-enabled?-])]
    (fn []
      (let [selected-conversation @selected-conversation-
            selected-convo-idx (:convo-idx selected-conversation)
            sessions @sessions-
            first? (= selected-convo-idx 0)
            last? (when selected-convo-idx
                    (>= selected-convo-idx (dec (count sessions))))
            conversation-detail (->conv-detail selected-conversation)
            conversation-ts (->conversation-ts selected-conversation)
            conversation-id (->conversation-id selected-conversation)
            convo-loading-or-present? (->convo-loading-or-present? conversation-detail)
            ces-score (find-convo-tag {:conversation-detail conversation-detail
                                       :tag-name tags.d/ces-score-tag-name})
            ces-score? @ces-score?-]
        [:div {:style {:background-color (style/alc-color "Background/secondary")
                       :flex "0 0 auto"
                       :display :flex
                       :flex-direction :column
                       :align-items :center
                       :gap 4
                       :padding "12px 0 0"}}
         (when @admin?-
           ^{:key (str "convo-id-" @copied-convo-id?*)}
           [alc/tooltip
            {:tooltip-content (if @copied-convo-id?*
                                "Copied"
                                "Copy Conversation ID")
             :target-content [c/interactive
                              :div {:on-click #(do
                                                 (re/dispatch [:core/copy-to-clipboard
                                                               conversation-id
                                                               {:notify? false}])
                                                 (reset! copied-convo-id?* true)
                                                 (util/wait 1500 (fn [] (reset! copied-convo-id?* false))))}
                              [:div {:style (cond-> {:color (style/alc-color "Text/secondary")
                                                     :display :flex
                                                     :align-items :center
                                                     :justify-content :center
                                                     :gap 9}
                                                    (not @copied-convo-id?*)
                                                    (assoc :cursor :pointer))}
                               [:span {:style {:color :inherit
                                               :font-size 14
                                               :font-weight 400
                                               :line-height 1.43}}
                                conversation-id]
                               [c/material-icon {:icon-type (if @copied-convo-id?*
                                                              :check-circle
                                                              :content-copy)
                                                 :style {:color (style/alc-color "Icons/secondary")
                                                         :font-size 14}}]]]}])
         [:div {:style {:display :flex
                        :align-items :center
                        :justify-content :space-between
                        :padding "0 16px"
                        :width "100%"}}
          (if selected-convo-idx
            (if first?
              [:div {:style {:flex "0 0 36px"}}]
              [alc/up-ghost-button {:icon-type :ArrowLeftIcon
                                    :disabled @next-page-loading?-
                                    :on-click #(re/dispatch [:sessions/move-conversation :prev])}])
            [c/spacer])
          (when conversation-ts
            [:div {:style {:display :flex
                           :align-items :center}}
             [:span {:style {:color (style/alc-color "Text/primary_header")
                             :font-size 20
                             :font-weight 400
                             :line-height 1.4}}
              conversation-ts]])
          (if selected-convo-idx
            (if (or (not last?) @next-page-loading?-)
              [alc/up-ghost-button {:icon-type :ArrowRightIcon
                                    :disabled @next-page-loading?-
                                    :on-click #(re/dispatch [:sessions/move-conversation :next])}]
              [:div {:style {:flex "0 0 36px"}}])
            [c/spacer])]
         (if (util/loading? conversation-detail)
           [:div {:style {:border-bottom "1px solid rgba(0, 0, 0, 0.05)"
                          :display :flex
                          :align-items :center
                          :justify-content :center
                          :flex-direction :column
                          :gap 12
                          :padding "12px 16px"
                          :width "100%"}}
            [:div {:style {:display :flex
                           :align-items :center
                           :justify-content :center
                           :gap 8
                           :width "100%"}}
             [c/loader-rectangle {:height 66
                                  :style {:border-radius 8
                                          :flex 1}}]
             [c/loader-rectangle {:height 66
                                  :style {:border-radius 8
                                          :flex 1}}]
             [c/loader-rectangle {:height 66
                                  :style {:border-radius 8
                                          :flex 1}}]]]
           (when convo-loading-or-present?
             [:div {:style {:border-bottom "1px solid rgba(0, 0, 0, 0.05)"
                            :display :flex
                            :flex-direction :column
                            :gap 12
                            :width "100%"}}
              [:div {:style {:display :flex
                             :flex-direction :column
                             :padding "12px 16px"
                             :gap 12
                             :width "100%"}}
               (into [:div {:style {:display :flex
                                    :align-items :center
                                    :justify-content :center
                                    :gap 8
                                    :width "100%"}}]
                     (map (fn [{:keys [category color]}]
                            (let [show-ces-score? (and (= category :marketing) ces-score?)]
                              [:div {:style {:background-color (style/alc-color "Background/primary")
                                             :border-radius 8
                                             :display :flex
                                             :flex-direction :column
                                             :align-items :center
                                             :flex 1
                                             :padding 10
                                             :gap 2
                                             :height 66}}
                               [:div {:style {:display :flex
                                              :align-items :center
                                              :gap 5}}
                                [:span {:style {:color (style/alc-color "Text/secondary")
                                                :font-size 12
                                                :font-weight 400
                                                :line-height 1.33}}
                                 (cond
                                   show-ces-score? "CES"
                                   (= category :satisfaction) @satisfaction-name-
                                   :else (s/capitalize (name category)))]]
                               (let [v (if show-ces-score?
                                         (:value ces-score)
                                         (get-in conversation-detail [:scores category]))
                                     v? (some-> v (str) (s/lower-case) (not= "null"))]
                                 [:span {:style (cond-> {:font-size 18
                                                         :font-weight 400
                                                         :line-height 1.56
                                                         :color color}
                                                        (not v?)
                                                        (assoc :opacity 0.6))}
                                  (or (when v? v) "-")])]))
                          [{:category :marketing
                            :color (style/alc-color "Chart/tech_blue")}
                           {:category :efficiency
                            :color (style/alc-color "Chart/orchid")}
                           {:category :satisfaction
                            :color (style/alc-color "Chart/turquoise")}]))
               (when (empty? (conversation->upsell-summary-tags selected-conversation))
                 (->> (if ces-score?
                        [{:label "Voicemail"
                          :name "caller-left-voicemail"}
                         {:label "Caller ID"
                          :name "caller-identified-automatically"}
                         {:label "First Time"
                          :name "first-contact-resolution"}]
                        [{:label "Upsize"
                          :name "size-upsell"}
                         {:label "Combo"
                          :name "combo-upsell"}
                         {:label "Add-on"
                          :name "add-on-upsell"}])
                      (map-indexed (fn [idx {:keys [label name]}]
                                     [:div {:style (cond-> {:flex "0 0 auto"
                                                            :display :flex
                                                            :flex-direction :column
                                                            :align-items :center
                                                            :gap 10
                                                            :padding "0 12px"}
                                                           (pos? idx)
                                                           (assoc :border-left (str "1px solid " (style/alc-color "Border/divider_secondary"))))}
                                      [:span {:style {:color (style/alc-color "Text/secondary")
                                                      :font-size 12
                                                      :font-weight 400
                                                      :line-height 1.33}}
                                       label]
                                      [tag-material-icon {:tags (:tags conversation-detail)
                                                          :name name
                                                          :size 15}]]))
                      (into [:div {:style {:display :flex
                                           :align-items :center
                                           :justify-content :center
                                           :padding "0px 16px"}}])))]]))]))))

(defn section-container [{:keys [default-expanded?]} _]
  (let [expanded?*- (re/ratom default-expanded?)]
    (fn [{:keys [title container-style]} & contents]
      (into [:div {:style container-style}
             [c/interactive
              :div {:on-click #(swap! expanded?*- not)
                    :style {:background-color (style/alc-color "Background/tertiary")
                            :border-bottom (str "1px solid " (style/alc-color "Border/divider"))
                            :cursor :pointer
                            :display :flex
                            :align-items :center
                            :justify-content :space-between
                            :padding 12
                            :transition "0.2s"}
                    :hover-style {:background-color (style/alc-color "Background/hover")}}
              [:span {:style {:color (style/alc-color "Text/primary")
                              :font-size 14
                              :font-weight 400
                              :line-height 1.43}}
               title]
              [c/material-icon {:icon-type (if @expanded?*-
                                             :keyboard-arrow-up
                                             :keyboard-arrow-down)
                                :style {:color (style/alc-color "Icons/secondary")
                                        :font-size 16}}]]]
            (when @expanded?*-
              contents)))))

(defn inner-section [{:keys [title style]} & contents]
  (into [:div {:style (merge {:border-bottom (str "1px solid " (style/alc-color "Border/divider"))
                              :color (style/alc-color "Text/primary")
                              :font-size 12
                              :font-weight 400
                              :line-height 1.33
                              :padding 16}
                             (when title
                               {:display :flex
                                :flex-direction :column
                                :gap 8})
                             style)}
         (when title
           [:div {:style {:color (style/alc-color "Text/secondary")
                          :font-size 12
                          :font-weight 600
                          :letter-spacing "0.5px"
                          :text-transform :uppercase
                          :line-height 1.33}}
            title])]
        contents))

(defn tag->outcome-details [{:keys [children]}]
  (when (not-empty children)
    (let [outcome-value (or (some->> children
                                     (filter #(= (:name %) "outcome"))
                                     (first)
                                     :value)
                            "Unknown")
          outcome-k (util/->kebab-case-keyword outcome-value)]
      {:outcome-value outcome-value
       :outcome-k outcome-k
       :outcome-color (condp = outcome-k
                        :resolved "#4AC53F"
                        :partially-resolved "#F99602"
                        :not-resolved "#FF8080"
                        :unresolved "#FF8080"
                        "#919296")})))

(defn sub-call-summary-row [{:keys [display-value value call-time start-ms include-outcome-spacing? outcome-value
                                    outcome-color outcome-icon-type]
                             :or {include-outcome-spacing? true}
                             :as t}]
  (let [display-v (or display-value (tag/tag->display-name {:value value}))
        details (tag->outcome-details t)
        outcome-value (or outcome-value (:outcome-value details))
        outcome-k (or (:outcome-k details) (some-> outcome-value (util/->kebab-case-keyword)))
        outcome-color (or outcome-color (:outcome-color details))]
    [:div {:style {:display :flex
                   :align-items :center
                   :gap 4
                   :padding "5px 0"}}
     [:span {:style {:color (style/alc-color "Text/primary")
                     :flex 1
                     :overflow :hidden
                     :text-overflow :ellipsis}}
      display-v]
     [:span {:style {:color (style/alc-color "Text/secondary")
                     :flex "0 0 86px"}}
      call-time]
     (when include-outcome-spacing?
       [:div {:style {:flex "0 0 125px"
                      :display :flex}}
        (when outcome-value
          [:div {:style {:background-color (util/hex->rgba outcome-color 0.3)
                         :border-radius 4
                         :flex "0 0 auto"
                         :display :flex
                         :align-items :center
                         :gap 4
                         :padding "3px 4px"}}
           (if outcome-icon-type
             [c/material-icon {:icon-type outcome-icon-type
                               :style {:color outcome-color
                                       :font-size 12}}]
             [tag-icon/tag-icon {:tag {:name "outcome"
                                       :value outcome-k}
                                 :color outcome-color
                                 :size 12}])
           [:span {:style {:color (style/alc-color "Text/primary")
                           :font-size 12
                           :font-weight 400
                           :line-height 1.5}}
            outcome-value]])])
     (when start-ms
       [:div {:style {:cursor :pointer
                      :display :flex
                      :align-items :center
                      :justify-content :center}
              :on-click #(re/dispatch [:voice-insights/active-session-jump-to-time {:jump-to start-ms
                                                                                    :play-audio? false
                                                                                    :scroll-to? true}])}
        [alc/tooltip
         {:target-content [c/material-icon {:icon-type :chat-bubble
                                            :style {:color (style/alc-color "Icons/secondary")
                                                    :font-size 14
                                                    :transition "0.2s"}
                                            :hover-style {:opacity 0.7}}]
          :tooltip-content (str "Jump to start of '" display-v "'")}]])]))

(defn conversation-detail-add-phase-end-times [conversation-detail]
  (let [duration-secs (:duration conversation-detail)
        sorted-phases (some->> conversation-detail
                               :utterance-tags
                               (filter #(= (:name %) "phase"))
                               (sort-by :start))
        phase-end-time-lookup (some->> sorted-phases
                                       (map-indexed (fn [phase-idx {:keys [start]}]
                                                      (let [phase-end (try
                                                                        (:start (nth sorted-phases (inc phase-idx)))
                                                                        (catch :default _
                                                                          (some-> duration-secs
                                                                                  (* 1000)
                                                                                  (js/Math.round))))]
                                                        [start phase-end])))
                                       (into {}))]
    (update conversation-detail :utterance-tags (fn [utterance-tags]
                                                  (->> utterance-tags
                                                       (mapv (fn [t]
                                                               (if (= (:name t) "phase")
                                                                 (assoc t :end (get phase-end-time-lookup (:start t)))
                                                                 t))))))))

(defn summary-section []
  (let [location-id->label @(re/subscribe [:locations/location-id->label-by-current-concept-id-])
        selected-conversation @(re/subscribe [:sessions/selected-conversation-])
        crew-type (->convo-crew-type selected-conversation)
        conversation-detail (->conv-detail selected-conversation)
        location-id (:location-id conversation-detail)
        location-label (or (when (and (not (util/loading? location-id->label))
                                      location-id)
                             (get location-id->label (util/parse-int location-id)))
                           "N/A")
        outcome (->> conversation-detail
                     :tags
                     (filter #(contains? (if (= crew-type "ai")
                                           #{"ai-outcome"}
                                           #{"outcome"})
                                         (:name %)))
                     (last))
        intent-utterances-by-value (->> conversation-detail
                                        :utterance-tags
                                        (filter #(= (:name %) "intent-utterance"))
                                        (group-by :value)
                                        (mapv (fn [[v vals]]
                                                [v (sort-by :start vals)]))
                                        (into {}))
        intent-summaries (some->> conversation-detail
                                  :tags
                                  (filter #(= (:name %) "intent-summary"))
                                  (mapv (fn [{:keys [value children] :as intent-summary}]
                                          (let [first-utterance-start (try
                                                                        (some-> intent-utterances-by-value
                                                                                (get value)
                                                                                (first)
                                                                                :start
                                                                                (util/parse-int))
                                                                        (catch :default _
                                                                          nil))
                                                first-utterance-start-display (try
                                                                                (some-> first-utterance-start
                                                                                        (/ 1000)
                                                                                        (js/Math.round)
                                                                                        (time/seconds->format))
                                                                                (catch :default _
                                                                                  nil))
                                                duration-display (when first-utterance-start-display
                                                                   (try
                                                                     (some->> children
                                                                              (filter #(= (:name %) "duration"))
                                                                              (first)
                                                                              :value
                                                                              (util/parse-int)
                                                                              (+ first-utterance-start)
                                                                              (#(/ % 1000))
                                                                              (js/Math.round)
                                                                              (time/seconds->format))
                                                                     (catch :default _
                                                                       nil)))]
                                            (assoc intent-summary :start-ms first-utterance-start
                                                                  :call-time (if first-utterance-start-display
                                                                               (str first-utterance-start-display
                                                                                    " - "
                                                                                    (or duration-display "N/A"))
                                                                               "N/A"))))))
        overall-summary (some-> (find-convo-tag {:conversation-detail conversation-detail
                                                 :tag-name "summary"
                                                 :tag-value "overall"})
                                :description)
        phase-summaries (some->> (conversation-detail-add-phase-end-times conversation-detail)
                                 :utterance-tags
                                 (filterv #(= (:name %) "phase"))
                                 (sort-by :start)
                                 (mapv (fn [{:keys [start end] :as phase-summary}]
                                         (let [->display-time #(some-> %
                                                                       (/ 1000)
                                                                       (js/Math.round)
                                                                       (time/seconds->format))
                                               start-display (->display-time start)
                                               end-display (->display-time end)]
                                           (assoc phase-summary :start-ms start
                                                                :call-time (if start-display
                                                                             (str start-display
                                                                                  " - "
                                                                                  (or end-display "N/A"))
                                                                             "N/A"))))))]
    [section-container {:default-expanded? true
                        :title "Summary"}
     [inner-section {:style {:display :flex
                             :align-items :center
                             :justify-content :center
                             :gap 10}}
      [:div {:style {:flex "0 0 auto"
                     :display :flex
                     :align-items :center
                     :gap 3}}
       [c/material-icon {:icon-type :headset-mic
                         :style {:color (style/alc-color "Icons/secondary")
                                 :font-size 14
                                 :flex "0 0 auto"}}]
       [:span {:style {:color (style/alc-color "Text/primary")
                       :line-height 1.5
                       :flex "0 0 auto"}}
        location-label]]
      [c/material-icon {:icon-type :arrow-forward
                        :style {:color (style/alc-color "Icons/secondary")
                                :font-size 14
                                :flex "0 0 auto"}}]
      [:div {:style {:flex "0 0 auto"
                     :display :flex
                     :align-items :center
                     :gap 3}}
       (if outcome
         [tag-icon/tag-icon {:tag outcome
                             :color (tag-icon/outcome-color outcome)
                             :size 14}]
         [:span {:style {:color (style/alc-color "Text/primary")
                         :line-height 1.5
                         :flex "0 0 auto"}}
          "N/A"])
       [:span {:style {:color (style/alc-color "Text/primary")
                       :line-height 1.5
                       :flex "0 0 auto"}}
        (tag/tag->display-name {:value (:value outcome)})]]]
     (when (not-empty intent-summaries)
       [inner-section {:title "Intents"}
        (->> intent-summaries
             (sort-by :start)
             (mapv (fn [intent-summary]
                     [sub-call-summary-row intent-summary]))
             (into [:div {:style {:display :flex
                                  :flex-direction :column}}]))])
     (when (not-empty phase-summaries)
       [inner-section {:title "Phases"}
        (->> phase-summaries
             (sort-by :start)
             (mapv (fn [phase-summary]
                     [sub-call-summary-row (assoc phase-summary :include-outcome-spacing? (not-empty intent-summaries))]))
             (into [:div {:style {:display :flex
                                  :flex-direction :column}}]))])
     (when (not-empty overall-summary)
       [inner-section {}
        overall-summary])]))

(defn title-values-entry [{:keys [title values]}]
  [:div {:style {:display :flex
                 :flex-direction :column
                 :gap 4}}
   [:div {:style {:color (style/alc-color "Text/secondary")
                  :font-size 12
                  :font-weight 400
                  :line-height 1.33}}
    title]
   (into [:div]
         (mapv (fn [v]
                 [:div {:style {:color (style/alc-color "Text/primary")
                                :font-size 12
                                :font-weight 400
                                :line-height 1.33}}
                  (or v "-")])
               values))])

(defn upsell-section []
  (let [selected-conversation @(re/subscribe [:sessions/selected-conversation-])
        upsell-summary-tags (conversation->upsell-summary-tags selected-conversation)]
    (when (not-empty upsell-summary-tags)
      (into [section-container {:default-expanded? false
                                :title "Upsell"}]
            (mapv (fn [tag]
                    [inner-section {:title (tag/tag->display-name {:name (-> (:name tag)
                                                                             (s/replace upsell-tag-prefix "")
                                                                             (s/replace summary-tag-suffix ""))})}
                     (->> (:values tag)
                          (mapv (fn [{:keys [action item outcome offset]}]
                                  (let [action (or (when (= outcome "decline")
                                                     "declined")
                                                   outcome
                                                   action)
                                        offered? (= action "offered")
                                        accepted? (= action "accepted")
                                        declined? (= action "declined")
                                        undetermined? (= action "undetermined")
                                        missed? (= action "missed")]
                                    [sub-call-summary-row {:display-value (util/capitalize-words item)
                                                           :call-time (some-> offset
                                                                              (/ 1000)
                                                                              (js/Math.round)
                                                                              (time/seconds->format))
                                                           :start-ms offset
                                                           :outcome-value (util/->capitalize-words action)
                                                           :outcome-color (cond
                                                                            offered? "#4AC53F"
                                                                            accepted? "#4AC53F"
                                                                            declined? "#F99602"
                                                                            undetermined? "#919296"
                                                                            missed? "#FF8080"
                                                                            :else "#FF8080")
                                                           :outcome-icon-type (cond
                                                                                offered? :check
                                                                                accepted? :thumb-up
                                                                                declined? :thumb-down
                                                                                undetermined? :remove
                                                                                missed? :close
                                                                                :else :close)}])))
                          (into [:div {:style {:display :flex
                                               :flex-direction :column}}]))])
                  upsell-summary-tags)))))

(defn pacing-section []
  (let [selected-conversation @(re/subscribe [:sessions/selected-conversation-])
        conversation-detail (->conv-detail selected-conversation)
        duration-secs (:duration conversation-detail)
        duration (some-> duration-secs (time/seconds->format))
        holds (some->> conversation-detail
                       :utterance-tags
                       (filter #(= (:name %) "hold"))
                       (sort-by :start)
                       (vec))
        hold-duration-sec-ranges (some->> holds
                                          (map-indexed (fn [idx {:keys [value start]}]
                                                         (when (= value "start")
                                                           (let [end-time (try
                                                                            (let [next-hold (nth holds (inc idx))]
                                                                              (when (= (:value next-hold) "end")
                                                                                (:start next-hold)))
                                                                            (catch :default _
                                                                              (* duration-secs 1000)))
                                                                 start-secs (try
                                                                              (some-> start (/ 1000) (js/Math.round))
                                                                              (catch :default _
                                                                                nil))
                                                                 end-secs (try
                                                                            (some-> end-time (/ 1000) (js/Math.round))
                                                                            (catch :default _
                                                                              nil))]
                                                             (when (and start-secs end-secs)
                                                               [start-secs end-secs])))))
                                          (filterv identity))
        total-hold-time (some->> hold-duration-sec-ranges
                                 (mapv (fn [[start end]]
                                         (- end start)))
                                 (apply +))
        holds? (not-empty hold-duration-sec-ranges)
        call-summary-timing (some->> conversation-detail
                                     :tags
                                     (filter #(= (:name %) "call-summary-timing"))
                                     (first))
        total-silence-time (some->> call-summary-timing
                                    :children
                                    (filter #(= (:name %) "silence-time"))
                                    (first)
                                    :value
                                    (js/Math.round))
        silences? (some-> total-silence-time (pos?))]
    (when (or holds? silences?)
      [section-container {:default-expanded? false
                          :title "Pacing"}
       [inner-section {:style {:display :flex
                               :gap 10}}
        [:div {:style {:flex 1
                       :display :flex
                       :flex-direction :column
                       :gap 6}}
         [title-values-entry {:title "Duration"
                              :values [duration]}]
         [title-values-entry {:title "Hold Time"
                              :values [(some-> (when (some-> total-hold-time (pos?)) total-hold-time)
                                               (time/seconds->format))]}]
         (when silences?
           [title-values-entry {:title "Silence Time"
                                :values [(some-> total-silence-time (time/seconds->format))]}])]
        [:div {:style {:flex 1
                       :display :flex
                       :flex-direction :column
                       :gap 6}}
         (if holds?
           [title-values-entry {:title "Holds"
                                :values (mapv (fn [[start end]]
                                                (str (time/seconds->format start)
                                                     " - "
                                                     (time/seconds->format end)))
                                              hold-duration-sec-ranges)}]
           [title-values-entry {:title "Silence Time"
                                :values [nil]}])]]])))

(defn recommendations-section []
  (let [selected-conversation @(re/subscribe [:sessions/selected-conversation-])
        conversation-detail (->conv-detail selected-conversation)
        improvement-recommendation-tags (some->> (util/when-not-loading conversation-detail)
                                                 :tags
                                                 (filter #(and (= (some-> (:name %) (util/->kebab-case-string))
                                                                  "improvement-recommendation")
                                                               (not= (some-> (:value %) (util/->kebab-case-string))
                                                                     "none")
                                                               (not-empty (:description %)))))]
    (when (not-empty improvement-recommendation-tags)
      (into [section-container {:default-expanded? false
                                :title "Recommendations"}]
            (mapv (fn [tag]
                    [inner-section {:title (tag/tag->display-name {:value (:value tag)})}
                     (:description tag)])
                  improvement-recommendation-tags)))))

(defn no-message-block [{:keys [message]}]
  [:div {:style {:display :flex
                 :align-items :center
                 :justify-content :center
                 :padding "30px 16px"
                 :height "100%"
                 :width "100%"}}
   [:span {:style {:font-size 13
                   :line-height 1.4
                   :font-weight 500
                   :color (style/alc-color "Text/secondary")
                   :text-align :center
                   :padding "16px"}}
    message]])

(defn transcript-card
  [_]
  (let [get-audio-el #(.querySelector js/document "#session-audio-player")
        auto-play-error?* (re/ratom false)
        play-audio-at-start-time #(when-let [audio-el (get-audio-el)]
                                    (set! (.-currentTime audio-el) (/ % 1000.0))
                                    (-> (.play audio-el)
                                        (.catch (fn [_]
                                                  (reset! auto-play-error?* true)))))
        crew-name- (re/subscribe [:voice-insights/crew-name-])
        ces-feature-enabled?- (re/subscribe [:voice-insights/ces-feature-enabled?-])]
    (re/create-class
      {:component-did-mount
       (fn [this]
         (let [{:keys [auto-play? start audio?]} (re/props this)]
           (when (and auto-play? audio?)
             (util/wait-for-scroll-end (js/document.getElementById "session-drawer-scroll-container")
                                       #(play-audio-at-start-time start))
             (util/smooth-scroll-to-view (re/dom-node this)))))

       :reagent-render
       (fn [{:keys [speaker transcript start end audio? auto-play? sentiment-tag tags container-style
                    inactive-container-style translation show-translation?]}]
         (let [crew? (not= speaker "user")
               audio-current-time @(re/subscribe [:sessions/audio-current-time-])
               audio-el (when audio? (get-audio-el))
               auto-play-error? (and auto-play? @auto-play-error?*)
               active? (or (and (not (nil? audio-current-time))
                                (<= start audio-current-time end)
                                (some? audio-el)
                                (not (.-paused audio-el)))
                           auto-play-error?)
               tags (remove #(contains? tag.d/conversation-drawer-hidden-utterance-tag-names-within-card-only (:name %))
                            tags)]
           [:div {:data-start-ms start
                  :style (merge {:padding "6px 12px 4px"
                                 :scroll-margin-top 198}
                                container-style
                                (when-not active?
                                  inactive-container-style))}
            [:div {:style (cond-> {:display :flex
                                   :flex-direction :column
                                   :gap 6
                                   :padding 12
                                   :border (str "1px solid " (style/alc-color "Border/divider_secondary"))
                                   :border-radius 6
                                   :background-color (if (and crew? (not active?))
                                                       (style/alc-color "Background/secondary")
                                                       :transparent)}

                                  active?
                                  (assoc :border (str "1px solid " (style/alc-color "Background/active"))
                                         :box-shadow "0px 3px 12px 0px rgba(153, 51, 240, 0.24), 0px 2px 6px 0px rgba(153, 51, 240, 0.06)")

                                  auto-play-error?
                                  (assoc :cursor :pointer))
                   :on-click (when auto-play-error?
                               #(do
                                  (reset! auto-play-error?* false)
                                  (play-audio-at-start-time start)
                                  (util/stop-event %)))}
             [:div {:style {:display :flex
                            :flex-direction :row
                            :align-items :center
                            :justify-content :space-between}}
              [:div {:style {:display :flex
                             :flex-direction :row
                             :align-items :center
                             :gap 4}}
               [:span {:style {:font-size 12
                               :line-height 1.5
                               :font-weight 600
                               :color (style/alc-color "Text/primary")}}
                ;; Only checking for 'crew' with 'ces' to make backwards compatible. New conversations should have
                ;; speaker of 'agent', 'agent-ai', or 'agent-human' in the data.
                (if (and @ces-feature-enabled?- (some-> speaker (s/includes? "crew")))
                  (vi.d/->speaker-display-name (s/replace speaker "crew" "agent"))
                  (vi.d/->speaker-display-name speaker))]
               [:span {:style {:font-size 12
                               :line-height 1.5
                               :font-weight 400
                               :color (style/alc-color "Text/primary")}}
                (time/seconds->format (js/Math.round (/ start 1000)))]
               (when sentiment-tag
                 [alc/tooltip
                  {:target-content [tag/sentiment-face {:size 14
                                                        :sentiment (:value sentiment-tag)}]
                   :tooltip-content (:description sentiment-tag)
                   :placement :top
                   :style {:margin-left 4}}])]
              (cond
                auto-play-error?
                [:div {:style {:color (style/alc-color "Common/active")
                               :font-size 11
                               :font-weight style/font-bold-weight
                               :letter-spacing "1px"
                               :text-transform :uppercase}}
                 "Click to Play"]

                active?
                [:div {:style {:position :relative
                               :width 21
                               :height 16}}
                 [alc/up-icon {:icon-type :ShWavesIcon
                               :color (style/alc-color "Common/active")}]]

                :else
                (when audio?
                  [c/interactive
                   :div {:style {:display :flex
                                 :cursor :pointer}
                         :on-click #(play-audio-at-start-time start)}
                   [c/material-icon {:icon-type :play-arrow
                                     :style {:color (style/alc-color "Icons/primary")
                                             :font-size 16}}]]))]
             [:span {:style {:font-size 14
                             :line-height 1.43
                             :font-weight 400
                             :color (style/alc-color "Text/primary")}}
              (anon.d/text transcript)]
             (when (and show-translation? (not-empty translation))
               [:div {:style {:border-left (str "2px solid " (style/alc-color "Border/divider"))
                              :line-height 1.1
                              :padding-left 8}}
                [:span {:style {:font-size 12
                                :line-height 1
                                :font-weight 400
                                :color (style/alc-color "Text/secondary")}}
                 (anon.d/text translation)]])
             (when (not-empty tags)
               (into [:div {:style {:display :flex
                                    :flex-wrap :wrap
                                    :gap 6}}]
                     (mapv (fn [t]
                             [tag/utterance-tag-pill (assoc t :show-description? true)])
                           tags)))]]))})))

(defn ignore-block [{:keys [tag ignore-block-config visible-ignore-blocks* container-style]}]
  (when (not-empty ignore-block-config)
    (let [value (:value tag)
          duration (- (some-> ignore-block-config (last) :end)
                      (some-> ignore-block-config (first) :start))
          convo-shown? (contains? @visible-ignore-blocks* ignore-block-config)]
      [:div {:style (merge {:display :flex
                            :align-items :center
                            :padding "12px 12px 12px 24px"}
                           container-style)}
       [c/material-icon {:icon-type (condp = value
                                      "echo" :surround-sound
                                      "user-chatter" :record-voice-over
                                      "silence" :volume-off
                                      :do-not-disturb-on)
                         :style {:color (style/alc-color "Icons/primary")
                                 :font-size 16
                                 :margin-right 4}}]
       [:span {:style {:color (style/alc-color "Text/primary")
                       :font-size 14
                       :font-weight 400
                       :line-height 1.43}}
        (str (tag/tag->display-name {:value value}) "... "
             (when (some-> duration (pos?)) (time/seconds->h-m-s (max (js/Math.round (/ duration 1000)) 1))))]
       [c/spacer]
       (when (not= value "silence")
         [:div {:style {:color (style/alc-color "Common/active")
                        :display :flex
                        :align-items :center
                        :gap 6
                        :cursor :pointer
                        :margin-left 6}
                :on-click #(swap! visible-ignore-blocks* (if convo-shown? disj conj) ignore-block-config)}
          [:span {:style {:color :inherit
                          :font-size 12
                          :line-height 1.5}}
           (if convo-shown?
             "Hide Conversation"
             "Show Conversation")]
          [c/material-icon {:icon-type (if convo-shown?
                                         :keyboard-arrow-up
                                         :keyboard-arrow-down)
                            :style {:color :inherit
                                    :font-size 14}}]])])))

(defn highlight-block-label [{:keys [start? label color icon-type]}]
  [:div {:style {:display :flex
                 :align-items :center
                 :gap 6
                 :padding (str (if start? 6 4) "px 12px " (if start? 4 6) "px 8px")}}
   [c/material-icon {:icon-type (or icon-type :check-circle)
                     :style {:color color
                             :font-size 12}}]
   [:span {:style {:color color
                   :font-size 14
                   :font-weight 700
                   :line-height 1.43}}
    label]])

(defn highlight-marker [{:keys [idx color style]}]
  [:div {:style (merge {:background-color color
                        :position :absolute
                        :top 0
                        :left (* (inc idx) 12)
                        :height "100%"
                        :width 2
                        :z-index 1}
                       style)}])

(defn utterances-transcript-list [_]
  (let [fuse-inst* (re/ratom nil)
        visible-ignore-blocks* (re/ratom #{})
        search-val- (re/subscribe [:form/val- (conj sessions.d/root-path :search-transcript) :value])
        show-translations?- (re/subscribe [:form/val- sessions.d/enable-translations-path :value])]
    (re/create-class
      {:component-did-mount
       (fn [this]
         (let [fuse-list (some->> (re/props this)
                                  :utterances
                                  (mapv (fn [{:keys [start transcript tags]}]
                                          {:start start
                                           :transcript transcript
                                           :tags (mapv tag/tag->display-name tags)})))]
           (reset! fuse-inst* (new Fuse
                                   (clj->js fuse-list)
                                   (clj->js (util/->camelCaseString {:keys [:transcript :tags]
                                                                     :include-score true
                                                                     :ignore-location true}))))))

       :reagent-render
       (fn [{:keys [utterances utterance-translations-by-start convo-start audio? start->utterance-sentiment search-val
                    ignore-blocks highlight-blocks]}]
         (let [highlight-blocks (when (empty? @search-val-) highlight-blocks)
               highlight-colors ["#9B34C8"
                                 "#15B1BA"
                                 "#69AEFF"
                                 "#4951E5"
                                 "#F63535"
                                 "#0279FF"
                                 "#F1C066"
                                 "#B2B2B2"
                                 "#9780FF"]
               highlight-blocks (some->> highlight-blocks
                                         (sort (fn [a b]
                                                 (if (= (:start-idx a) (:start-idx b))
                                                   (compare (:end-idx b) (:end-idx a))
                                                   (compare (:start-idx a) (:start-idx b)))))
                                         (map-indexed (fn [block-idx block]
                                                        (assoc block :color (or (:color block)
                                                                                (try
                                                                                  (nth highlight-colors block-idx)
                                                                                  (catch :default _
                                                                                    (util/str->hex (:start-label block)))))))))
               overall-highlight-block-color-idx-lookup (some->> highlight-blocks
                                                                 (map-indexed (fn [hb-idx {:keys [color]}]
                                                                                [color hb-idx]))
                                                                 (into {}))
               start-highlights (some->> highlight-blocks
                                         (filterv :start-idx)
                                         (group-by :start-idx)
                                         (mapv (fn [[start-idx vals]]
                                                 [start-idx (mapv (fn [v] (assoc v :label (:start-label v))) vals)]))
                                         (into {}))
               end-highlights (some->> highlight-blocks
                                       (filterv :end-idx)
                                       (group-by :end-idx)
                                       (mapv (fn [[end-idx vals]]
                                               [end-idx (mapv (fn [v] (assoc v :label (:end-label v))) vals)]))
                                       (into {}))
               score-threshold 0.6
               filtered-utterance-starts (some->> (when (and @fuse-inst* (not-empty search-val))
                                                    (.search @fuse-inst* search-val))
                                                  (js->clj)
                                                  (util/->kebab-case-keywords)
                                                  (filter #(< (:score %) score-threshold))
                                                  (map (fn [{:keys [item]}]
                                                         (:start item)))
                                                  (into #{}))
               filtered-utterances (filter #(or (not filtered-utterance-starts)
                                                (contains? filtered-utterance-starts (:start %)))
                                           utterances)
               show-translations? @show-translations?-]
           (if (empty? filtered-utterances)
             [no-message-block {:message (str "No Results For \"" search-val "\"")}]
             (->> filtered-utterances
                  (sort (fn [a b]
                          (let [sa (:start a)
                                sb (:start b)
                                ta (:transcript a)
                                tb (:transcript b)]
                            (cond
                              (< sa sb) -1
                              (> sa sb) 1
                              (and (nil? ta) (some? tb)) -1
                              (and (some? ta) (nil? tb)) 1
                              :else 0))))
                  (map-indexed (fn [idx {:keys [speaker start end transcript tags]}]
                                 (let [ignore-tag (->> tags
                                                       (filter #(= (:name %) "ignore"))
                                                       (first))
                                       ignore-block-config (when (and (not-empty ignore-blocks) ignore-tag)
                                                             (->> (get ignore-blocks (:value ignore-tag))
                                                                  (filterv (fn [conf]
                                                                             (and (>= idx (:idx (first conf)))
                                                                                  (<= idx (:idx (last conf))))))
                                                                  (first)))
                                       visible-ignore-block? (some->> ignore-block-config
                                                                      (get @visible-ignore-blocks*))
                                       highlight-blocks-in-play (some->> highlight-blocks
                                                                         (map-indexed (fn [block-idx i]
                                                                                        (assoc i :idx block-idx)))
                                                                         (filter #(and (>= idx (:start-idx %))
                                                                                       (or (not (:end-idx %))
                                                                                           (<= idx (:end-idx %))))))
                                       transitive-prior-overlaps (fn [in-idx active-blocks]
                                                                   (let [ended (filter #(> in-idx (:end-idx %)) highlight-blocks)
                                                                         overlaps? (fn [a e]
                                                                                     (and (> (:start-idx a) (:start-idx e))
                                                                                          (<= (:start-idx a) (:end-idx e))))]
                                                                     (loop [frontier active-blocks
                                                                            found #{}
                                                                            remaining (vec ended)]
                                                                       (let [new-overlaps (filterv #(some (fn [f] (overlaps? f %)) frontier) remaining)]
                                                                         (if (empty? new-overlaps)
                                                                           found
                                                                           (recur new-overlaps
                                                                                  (into found new-overlaps)
                                                                                  (remove (set new-overlaps) remaining)))))))
                                       prior-overlap-highlight-blocks (transitive-prior-overlaps idx highlight-blocks-in-play)
                                       next-prior-overlap-highlight-blocks (transitive-prior-overlaps (inc idx) highlight-blocks-in-play)
                                       highlight-markers (some->> highlight-blocks-in-play
                                                                  (mapv #(select-keys % [:color :start-idx :end-idx :idx])))
                                       highlight-spacing (* 12 (+ (count highlight-markers)
                                                                  (count prior-overlap-highlight-blocks)))
                                       more-than-1-hm (> (count highlight-markers) 1)
                                       prior-overlap-remove-and-count (fn [hm]
                                                                        (some->> prior-overlap-highlight-blocks
                                                                                 (remove #(or (> (:start-idx %) (:start-idx hm))
                                                                                              (> (get overall-highlight-block-color-idx-lookup (:color %))
                                                                                                 (get overall-highlight-block-color-idx-lookup (:color hm)))))
                                                                                 (count)))]
                                   [:div
                                    (when (and ignore-tag (some-> ignore-block-config (first) :idx (= idx)))
                                      (into [:div {:style {:padding-left highlight-spacing
                                                           :position :relative}}
                                             [ignore-block {:idx idx
                                                            :tag ignore-tag
                                                            :ignore-block-config ignore-block-config
                                                            :visible-ignore-blocks* visible-ignore-blocks*}]]
                                            ;; Don't show the highlights if this is the first entry
                                            (when (not= idx 0)
                                              (map-indexed (fn [h-idx {:keys [color] :as hm}]
                                                             [highlight-marker {:idx (+ h-idx (prior-overlap-remove-and-count hm))
                                                                                :color color}])
                                                           highlight-markers))))
                                    (when (or (not ignore-tag) visible-ignore-block?)
                                      (let [start-highlight-vals (get start-highlights idx)
                                            start-highlight-count (count start-highlight-vals)
                                            start-highlight-color->idx (some->> start-highlight-vals
                                                                                (map-indexed (fn [hb-idx h]
                                                                                               [(:color h) hb-idx]))
                                                                                (into {}))]
                                        (some->> start-highlight-vals
                                                 (map-indexed (fn [hb-idx h]
                                                                (let [starting-hms (filter #(= (:start-idx %) idx) highlight-markers)
                                                                      full-left-padding? (and more-than-1-hm
                                                                                              (or (not-empty prior-overlap-highlight-blocks)
                                                                                                  (> start-highlight-count 1)
                                                                                                  (some #(< (:idx %) (dec (count highlight-markers))) starting-hms)))
                                                                      hms-to-use (->> (when more-than-1-hm
                                                                                        (if full-left-padding?
                                                                                          highlight-markers
                                                                                          (drop (+ hb-idx (dec start-highlight-count))
                                                                                                highlight-markers)))
                                                                                      (map-indexed (fn [hm-to-use-idx hm-to-use]
                                                                                                     (assoc hm-to-use :idx hm-to-use-idx))))]
                                                                  (into [:div {:style {:padding-left (if (and full-left-padding?
                                                                                                              (> start-highlight-count 1))
                                                                                                       highlight-spacing
                                                                                                       (when (pos? highlight-spacing)
                                                                                                         (- highlight-spacing 12)))
                                                                                       :position :relative}}
                                                                         [highlight-block-label (assoc h :start? true)]]
                                                                        (map-indexed (fn [h-idx {:keys [color] :as hm}]
                                                                                       (let [marker-count (count highlight-markers)
                                                                                             crossover-marker? (and full-left-padding?
                                                                                                                    (= (:start-idx hm) idx)
                                                                                                                    (= (:color h) color))
                                                                                             prior-count (prior-overlap-remove-and-count hm)
                                                                                             middle-spacer-count (- (count prior-overlap-highlight-blocks)
                                                                                                                    prior-count)
                                                                                             idx-with-spacing (+ h-idx prior-count)]
                                                                                         (when (or (< (:start-idx hm) idx)
                                                                                                   (and (or (> start-highlight-count 1)
                                                                                                            (< h-idx (dec (count hms-to-use))))
                                                                                                        (<= (get start-highlight-color->idx color)
                                                                                                            hb-idx)))
                                                                                           [:div
                                                                                            (when crossover-marker?
                                                                                              [:div {:style {:background-color color
                                                                                                             :position :absolute
                                                                                                             :top "calc(50% - 2px)"
                                                                                                             :left (* (inc idx-with-spacing) 12)
                                                                                                             :height 2
                                                                                                             :width (- (* (+ (- marker-count h-idx)
                                                                                                                             middle-spacer-count)
                                                                                                                          12)
                                                                                                                       6)
                                                                                                             :z-index 2}}])
                                                                                            [highlight-marker {:idx idx-with-spacing
                                                                                                               :color color
                                                                                                               :style (when crossover-marker?
                                                                                                                        {:height "50%" :top "50%"})}]])))
                                                                                     hms-to-use)))))
                                                 (into [:div]))))
                                    (when (or (not ignore-tag) visible-ignore-block?)
                                      (into [:div {:style {:position :relative
                                                           :padding-left highlight-spacing}}
                                             [transcript-card (cond-> {:speaker speaker
                                                                       :transcript transcript
                                                                       :start start
                                                                       :sentiment-tag (get start->utterance-sentiment start)
                                                                       :end end
                                                                       :audio? audio?
                                                                       :auto-play? (some-> start (= convo-start))
                                                                       :tags tags
                                                                       :show-translation? show-translations?
                                                                       :translation (some-> utterance-translations-by-start
                                                                                            (get start)
                                                                                            :description)}
                                                                      visible-ignore-block?
                                                                      (assoc :inactive-container-style {:opacity 0.6}))]]
                                            (map-indexed (fn [h-idx {:keys [color] :as hm}]
                                                           [highlight-marker {:idx (+ h-idx (prior-overlap-remove-and-count hm))
                                                                              :color color}])
                                                         highlight-markers)))
                                    (when (or (not ignore-tag) visible-ignore-block?)
                                      (let [end-highlight-vals (get end-highlights idx)
                                            end-highlight-count (count end-highlight-vals)
                                            end-highlight-color->idx (some->> end-highlight-vals
                                                                              (map-indexed (fn [hb-idx h]
                                                                                             [(:color h) hb-idx]))
                                                                              (into {}))]
                                        (some->> end-highlight-vals
                                                 (map-indexed (fn [hb-idx h]
                                                                (let [ending-hms (filter #(= (:end-idx %) idx) highlight-markers)
                                                                      full-left-padding? (and more-than-1-hm
                                                                                              (or (not-empty next-prior-overlap-highlight-blocks)
                                                                                                  (> end-highlight-count 1)
                                                                                                  (some #(< (:idx %) (dec (count highlight-markers))) ending-hms)))
                                                                      hms-to-use (->> (when more-than-1-hm
                                                                                        (if full-left-padding?
                                                                                          highlight-markers
                                                                                          (drop (+ hb-idx (dec end-highlight-count))
                                                                                                highlight-markers)))
                                                                                      (map-indexed (fn [hm-to-use-idx hm-to-use]
                                                                                                     (assoc hm-to-use :idx hm-to-use-idx))))]
                                                                  (into [:div {:style {:padding-left (if full-left-padding?
                                                                                                       highlight-spacing
                                                                                                       (when (pos? highlight-spacing)
                                                                                                         (- highlight-spacing 12)))
                                                                                       :position :relative}}
                                                                         [highlight-block-label h]]
                                                                        (map-indexed (fn [h-idx {:keys [color] :as hm}]
                                                                                       (let [marker-count (count highlight-markers)
                                                                                             crossover-marker? (and full-left-padding?
                                                                                                                    (= (:end-idx hm) idx)
                                                                                                                    (= (:color h) color))
                                                                                             prior-count (prior-overlap-remove-and-count hm)
                                                                                             middle-spacer-count (- (count prior-overlap-highlight-blocks)
                                                                                                                    prior-count)
                                                                                             idx-with-spacing (+ h-idx prior-count)]
                                                                                         (when (or (> (:end-idx hm) idx)
                                                                                                   (and (or crossover-marker?
                                                                                                            (> end-highlight-count 1)
                                                                                                            (< h-idx (dec (count hms-to-use))))
                                                                                                        (>= (get end-highlight-color->idx color)
                                                                                                            hb-idx)))
                                                                                           [:div
                                                                                            (when crossover-marker?
                                                                                              [:div {:style {:background-color color
                                                                                                             :position :absolute
                                                                                                             :top "calc(50% - 2px)"
                                                                                                             :left (* (inc idx-with-spacing) 12)
                                                                                                             :height 2
                                                                                                             :width (- (* (+ (- marker-count h-idx)
                                                                                                                             middle-spacer-count)
                                                                                                                          12)
                                                                                                                       6)
                                                                                                             :z-index 2}}])
                                                                                            [highlight-marker {:idx idx-with-spacing
                                                                                                               :color color
                                                                                                               :style (when crossover-marker?
                                                                                                                        {:height "50%"})}]])))
                                                                                     hms-to-use)))))
                                                 (into [:div]))))])))
                  (into [:div {:style {:display :flex
                                       :flex-direction :column
                                       :padding "12px 0"}}
                         (when (not-empty utterance-translations-by-start)
                           [:div {:style {:padding "0 12px 3px"}}
                            [alc/up-toggle {:form-path sessions.d/enable-translations-path
                                            :form-name :value
                                            :size "sm"
                                            :variant "pill"
                                            :label "Show Translations"}]])])))))})))

(defn call-transcript-section []
  (let [qps @(re/subscribe [:router/current-query-params-])
        selected-conversation @(re/subscribe [:sessions/selected-conversation-])
        conversation-detail (->conv-detail selected-conversation)
        convo-loading-or-present? (->convo-loading-or-present? conversation-detail)
        convo-loading? (util/loading? conversation-detail)
        audio? (not-empty (:audio-url conversation-detail))
        search-path (conj sessions.d/root-path :search-transcript)
        search-val @(re/subscribe [:form/val- search-path :value])]
    [section-container {:default-expanded? true
                        :title "Transcript"}
     (when-not convo-loading?
       [:div
        [:div {:style {:background-color (style/alc-color "Background/secondary")
                       :border-bottom (str "1px solid " (style/alc-color "Border/divider"))
                       :display :flex
                       :flex-direction :column
                       :gap 13
                       :padding 16
                       :position :sticky
                       :top 58
                       :width "100%"
                       :z-index (style/z :medium)}}
         (when audio?
           [audio/simple-audio-player {:audio-id :session-audio-player
                                       :url (:audio-url conversation-detail)
                                       :extra-on-time-update #(re/dispatch [:sessions/set-audio-current-time (* % 1000)])
                                       :show-playback-speed? true
                                       :space-keybinding? false
                                       :playback-speed-path (conj sessions.d/root-path :conversation-audio)
                                       :style {:padding 0}}])
         (when convo-loading-or-present?
           [alc/up-input {:placeholder "Search Transcript"
                          :form-path search-path
                          :form-name :value}])]
        (if convo-loading-or-present?
          (let [conversation-detail (conversation-detail-add-phase-end-times conversation-detail)
                utterance-translations-by-start (:utterance-translations-by-start conversation-detail)
                utterance-sentiment? #(= (some-> (:name %) (util/->kebab-case-string)) "utterance-sentiment")
                start->utterance-sentiment (->> conversation-detail
                                                :utterance-tags
                                                (filter utterance-sentiment?)
                                                (map (fn [t] [(:start t) t]))
                                                (into {}))
                start->tags (->> conversation-detail
                                 :utterance-tags
                                 (group-by :start))
                utterances (->> conversation-detail
                                :utterances
                                (map-indexed (fn [idx {:keys [start] :as utt}]
                                               (assoc utt :idx idx
                                                          :tags (->> (get start->tags start)
                                                                     (remove #(tag.d/conversation-drawer-hidden-utterance-tag-names
                                                                                (:name %))))))))
                ignore-blocks (->> utterances
                                   (filter (fn [{:keys [tags]}] (some #(= (:name %) "ignore") tags)))
                                   (mapv (fn [{:keys [idx start end tags]}]
                                           {:idx idx
                                            :start start
                                            :end end
                                            :ignore-value (->> tags
                                                               (filter #(= (:name %) "ignore"))
                                                               (first)
                                                               :value)}))
                                   (group-by :ignore-value)
                                   (reduce-kv (fn [m k items]
                                                (assoc m k (reduce (fn [runs {:keys [idx] :as item}]
                                                                     (if (and (seq runs)
                                                                              (= (inc (:idx (peek (peek runs)))) idx))
                                                                       (update runs (dec (count runs)) conj item)
                                                                       (conj runs [item])))
                                                                   []
                                                                   items)))
                                              {}))
                intent->outcome (->> conversation-detail
                                     :tags
                                     (filter #(= (:name %) "intent-summary"))
                                     (map (fn [{:keys [value children]}]
                                            [value (->> children (filter #(= (:name %) "outcome")) (first) :value)]))
                                     (into {}))
                intent-blocks (->> utterances
                                   (mapv (fn [{:keys [idx start end tags]}]
                                           (->> tags
                                                (filter #(= (:name %) "intent-utterance"))
                                                (mapv (fn [intent-utterance]
                                                        (assoc (select-keys intent-utterance [:name :value])
                                                          :utterance-details {:idx idx
                                                                              :start start
                                                                              :end end}))))))
                                   (flatten)
                                   (group-by #(select-keys % [:name :value]))
                                   (mapv (fn [[k vals]]
                                           (let [start (-> vals (first) :utterance-details)
                                                 end (some-> vals (last) :utterance-details)
                                                 outcome (get intent->outcome (:value k))
                                                 base-label (tag/tag->display-name {:name "intent"
                                                                                    :value (:value k)})]
                                             {:start-label base-label
                                              :end-label (str base-label " - " (or outcome "Complete"))
                                              :start-idx (:idx start)
                                              :end-idx (:idx end)
                                              :icon-type (some-> outcome
                                                                 (util/->kebab-case-keyword)
                                                                 (tag-icon/get-outcome-material-icon-type))}))))
                utterance-start->idx (->> utterances
                                          (mapv (fn [{:keys [idx start]}]
                                                  [start idx]))
                                          (into {}))
                phase-blocks (->> utterances
                                  (mapv (fn [{:keys [idx tags]}]
                                          (->> tags
                                               (filter #(= (:name %) "phase"))
                                               (mapv (fn [phase-utterance]
                                                       (assoc (select-keys phase-utterance [:name :value])
                                                         :utterance-details {:idx idx
                                                                             :end-idx (or (some-> (get utterance-start->idx (:end phase-utterance))
                                                                                                  (dec)
                                                                                                  (max 0))
                                                                                          (dec (count utterances)))}))))))
                                  (flatten)
                                  (group-by #(select-keys % [:name :value]))
                                  (mapv (fn [[k vals]]
                                          (let [start (-> vals (first) :utterance-details)
                                                end (some-> vals (last) :utterance-details)
                                                base-label (tag/tag->display-name {:name "phase"
                                                                                   :value (:value k)})]
                                            {:start-label base-label
                                             :end-label (str base-label " - End")
                                             :start-idx (:idx start)
                                             :end-idx (:end-idx end)
                                             :icon-type :check-circle}))))]
            [utterances-transcript-list {:utterances utterances
                                         :utterance-translations-by-start utterance-translations-by-start
                                         :convo-start (:start selected-conversation)
                                         :audio? audio?
                                         :start->utterance-sentiment start->utterance-sentiment
                                         :search-val search-val
                                         :ignore-blocks ignore-blocks
                                         :highlight-blocks (concat intent-blocks phase-blocks)}])
          [no-message-block {:message (str "No Conversation Found For \""
                                           (-> qps :conv (sessions.d/conv-qp->conversation) :conversation-id)
                                           "\"")}])])]))

(defmethod l/panel-right-view
  :sessions/conversation-panel [_]
  (let [selected-conversation @(re/subscribe [:sessions/selected-conversation-])
        conversation-detail (->conv-detail selected-conversation)
        convo-loading-or-present? (->convo-loading-or-present? conversation-detail)
        loading? (util/loading? conversation-detail)]
    [:div {:id :session-drawer-scroll-container
           :style (cond-> {:overflow :auto}
                          loading?
                          (assoc :display :flex
                                 :flex-direction :column))}
     [header]
     [session-overview]
     (when convo-loading-or-present?
       (if loading?
         [alc/up-loader-with-label {:label "Loading Conversation..."
                                    :style {:flex 1
                                            :height :auto
                                            :min-height :auto}}]
         [:div
          [summary-section]
          [upsell-section]
          [pacing-section]
          [recommendations-section]
          [call-transcript-section]]))]))
